import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAppRegisteredStudentsPerGroupUseCaseInterface } from 'domain/usecases';

export class RemoteGetAppRegisteredStudentsPerGroup
  implements GetAppRegisteredStudentsPerGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAppRegisteredStudentsPerGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAppRegisteredStudentsPerGroupUseCaseInterface.Params,
  ): Promise<GetAppRegisteredStudentsPerGroupUseCaseInterface.Result> {
    const { reportType, ...rest } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${reportType}`, rest),
      responseType: params.reportType === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
